import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ApiService } from 'app/services/api.service';
import moment from 'moment-timezone';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'password-change-dialog',
    templateUrl: './password-change-dialog.component.html',
    styleUrls: ['./password-change-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [FormsModule, MatDialogModule, TranslateModule]
})
export class PasswordChangeDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PasswordChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ApiService
  ) { }

  enhancedSecurity: boolean = false;
  passwordChangeError: string;
  expiredOldPassword: string;
  expiredNewPassword: string;
  expiredNewPasswordConfirm: string;

  private getPasswordValidationCode(err: any): string {
    return err?.error?.code || "PASSWORD_NOT_VALID";
  }

  changePassword(): void {
    this.passwordChangeError = "";
    if (this.expiredNewPassword != this.expiredNewPasswordConfirm) {
      this.passwordChangeError = "PASSWORDS_DONT_MATCH";
      return;
    }
    const data: any = {
      oldPassword: this.expiredOldPassword,
      newPassword: this.expiredNewPasswordConfirm
    }
    this.api.changePassword(data).subscribe(res => {
      //Get current user object from localStorage
      const user = JSON.parse(localStorage.getItem('user'));
      //Change new token and password change date into the object
      user.passwordChanged = moment().utc();
      //Set it back into the localStorage
      localStorage.setItem('user', JSON.stringify(user));
      //Close the dialog
      this.dialogRef.close();
    }, err => {
      this.passwordChangeError = this.getPasswordValidationCode(err);
    })
  }

  ngOnInit() {
    const features = JSON.parse(localStorage.getItem('features'))
    if (features && features.indexOf('EnhancedSecurity') !== -1) {
      return this.enhancedSecurity = true;
    }
  }
}
